import { render, staticRenderFns } from "./electricBoardPics.vue?vue&type=template&id=2316239b&scoped=true"
import script from "./electricBoardPics.vue?vue&type=script&lang=js"
export * from "./electricBoardPics.vue?vue&type=script&lang=js"
import style0 from "./electricBoardPics.vue?vue&type=style&index=0&id=2316239b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2316239b",
  null
  
)

export default component.exports